module.exports = __webpack_public_path__ + "img/mobile-map-mobilia.6dd7a763.png";